import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './RelayDetail.css';
import { FaArrowLeft } from 'react-icons/fa';
import { useSystem } from '../../context/SystemContext';
import { CSS_STATUS_CLASS } from '../../context/enums';
import { capitalizeFirst } from '../../utils/stringUtils';

const RelayDetail = () => {
  const { relayId } = useParams();
  const navigate = useNavigate();
  const { relays, getDisplayStatus, getStatusColorClass, getRelayName } = useSystem();

  // Find the actual relay data based on the ID
  const currentRelayData = relays.find(relay => relay.id === relayId);

  // Only use actual relay data - no fallback information
  const displayDetails = currentRelayData ? [
    { label: 'Name', value: getRelayName(currentRelayData.id) || 'Unknown' },
    { label: 'Status', value: getDisplayStatus(currentRelayData.status) || 'Unknown' },
    { label: 'Connection', value: currentRelayData.connection ? capitalizeFirst(currentRelayData.connection) : 'Unknown' },
    { label: 'Last Update', value: currentRelayData.timeLastUpdate ?
      new Date(currentRelayData.timeLastUpdate).toLocaleString() : 'Never' }
  ] : [];

  const displayName = currentRelayData ? getRelayName(currentRelayData.id) : `Relay ${relayId}`;
  const displayIcon = currentRelayData ? currentRelayData.icon : null;

  const handleBack = () => {
    navigate('/system');
  };

  return (
    <div className="relay-detail-page">
      <div className="relay-detail-header">
        <button className="back-button" onClick={handleBack}>
          <FaArrowLeft />
        </button>
        <div className="relay-detail-title">
          {displayIcon && <div className="relay-detail-icon">{displayIcon}</div>}
          <h2 style={{ margin: 0 }}>{displayName}</h2>
        </div>
      </div>
      
      <div className="relay-detail-content">
        {currentRelayData ? (
          displayDetails.map((detail, index) => {
            const colorClass = detail.label === 'Status' ? getStatusColorClass(currentRelayData.status) : '';
            const alertClass = detail.value.toLowerCase().includes('error') ||
                              detail.value.toLowerCase() === 'disconnected' ||
                              detail.value.toLowerCase() === 'offline' ?
                              CSS_STATUS_CLASS.ALERT : '';
            return (
              <div key={index} className="detail-item">
                <div className="detail-label">{detail.label}</div>
                <div className={`detail-value ${colorClass || alertClass}`}>
                  {detail.value}
                </div>
              </div>
            );
          })
        ) : (
          <div className="no-relay-data">
            <div className="no-data-text">No relay data available</div>
            <div className="no-data-subtext">
              Connect to a CBW device and ensure the relay with ID "{relayId}" is available.
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default RelayDetail;
